var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2139 15.3662H89.7861C95.1085 15.3664 99.4998 19.7577 99.5 25.0801V75.0801C99.5 80.4027 95.1087 84.7947 89.7861 84.7949H11.2139C5.89134 84.7947 1.5 80.4027 1.5 75.0801V25.0801L1.5127 24.584C1.77548 19.4876 6.05779 15.3664 11.2139 15.3662ZM11.2139 20.5088C8.64407 20.509 6.6428 22.5103 6.64258 25.0801V75.0801C6.64258 77.6501 8.64393 79.6521 11.2139 79.6524H89.7861C92.3561 79.6521 94.3574 77.6501 94.3574 75.0801V38.3662H12.2139V33.2236H94.3574V25.0801C94.3572 22.5103 92.3559 20.509 89.7861 20.5088H11.2139Z",
    fill: "currentColor",
    stroke: "var(--background)",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.a5d2c323dba3e488991bb5244b0f77ce.svg";
export { ForwardRef as ReactComponent };